import produce from 'immer';
import { IMemberChoices } from '../api/models/memberchoice/memberchoice.types';
import { initialRootState } from '../initialRootState';
import { EMemberChoicesActionType, IMemberChoicesAction } from './actions';

export interface IProfileMemberChoicesState {
  values?: IMemberChoices;
}

export interface IMemberChoicesState {
  [id: string]: IProfileMemberChoicesState;
}

export const memberchoicesReducer = (
  currentState: IMemberChoicesState = initialRootState.memberchoices,
  action: IMemberChoicesAction
): IMemberChoicesState =>
  produce(currentState, draft => {
    switch (action.type) {
      case EMemberChoicesActionType.GET_SUCCESS:
        draft[action.payload.accountId] = { values: action.payload.values };
        break;
      case EMemberChoicesActionType.UPDATE_SUCCESS:
        // We merge old values (coming from fastforward) with new values
        draft[action.payload.accountId].values = {
          ...draft[action.payload.accountId].values,
          ...action.payload.values,
        };
        break;
    }
  });
